import React from 'react';
import { List, Icon, Button, Avatar } from 'antd';
import PropTypes from 'prop-types';

const ConnectionTile = ({ connection, isActive, onEdit, onSelect }) => (
  <List.Item
    style={{
      background: '#334453',
      padding: '16px',
      margin: '4px 8px',
      position: 'relative',
      overflow: 'hidden',
      ...(isActive && {
        background: 'rgba(2, 121, 192, 1)',
        borderLeft: '8px',
        borderRight: '8px',
        borderBottom: '0px',
        borderTop: '0px',
        borderStyle: 'solid',
        borderColor: '#0060A7',
        margin: 0,
        boxShadow: '0px 5px 10px -2px #333',
      }),
    }}
    actions={[
      isActive
        ? <div>Connected</div>
        : <Button size="small" ghost onClick={() => onSelect(connection.id)}>Connect</Button>,
    ]}
    extra={
      !isActive && (
        <Button icon="setting" onClick={() => onEdit(connection.id)} ghost shape="circle" />
      )
    }
  >
    <List.Item.Meta
      title={connection.name}
      description={<div style={{ maxWidth: '224px', overflowWrap: 'break-word' }}>{connection.description}</div>}
    />
    <Icon
      type="api"
      style={{
        fontSize: '96px',
        position: 'absolute',
        right: '5%',
        top: '50%',
        marginTop: '-48px',
        color: 'rgba(255, 255, 255, 0.1)',
      }}
    />
  </List.Item>
);

ConnectionTile.propTypes = {
  connection: PropTypes.object.isRequired,
  isActive: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default ConnectionTile;
